import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";

import { OpenChangePlanModal } from "scenes/Settings/components/AccountSettings/components/ChangePlanModal/action";

import { MailToButton, NavigateButton } from "..";

function UpgradeButton({
  email,
  upgradeSubject,
  description,
  onClick,
  content,
  buttonData,
  ...props
}) {
  const ff = useFeatures("insights-upgrade-plan.callToActionButton");
  const ctaButton = buttonData || ff;
  const dispatch = useDispatch();

  switch (ctaButton?.type) {
    case "redirect":
      return (
        <NavigateButton
          link={ctaButton.link}
          onClick={onClick}
          urlParams={[
            ["email", email],
            ["subject", upgradeSubject],
            ["content", description],
          ]}
          {...props}
        >
          {content || ctaButton.text || "Change Plan"}
        </NavigateButton>
      );
    case "launchChangePlanModal":
      return (
        <Button
          primary
          onClick={() => {
            dispatch(OpenChangePlanModal(ctaButton?.coupon));
            onClick();
          }}
          {...props}
        >
          {content || ctaButton.text || "Change Plan"}
        </Button>
      );
    default:
      return (
        <MailToButton
          mailto={ctaButton?.email || "support@myhubly.com"}
          subject={ctaButton?.subject || upgradeSubject}
          onClick={onClick}
          {...props}
        >
          {content || ctaButton?.text || "Change Plan"}
        </MailToButton>
      );
  }
}

UpgradeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  email: PropTypes.string,
  upgradeSubject: PropTypes.string,
  description: PropTypes.string,
  content: PropTypes.string,
  buttonData: PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string,
    email: PropTypes.string,
    link: PropTypes.string,
    subject: PropTypes.string,
    coupon: PropTypes.string,
  }),
};

UpgradeButton.defaultProps = {
  email: undefined,
  upgradeSubject: "Upgrade My Plan",
  description: "",
  content: undefined,
  buttonData: undefined,
};

export default UpgradeButton;
